import { createContext } from 'react';

const ChatbarContext = createContext(null);

export default ChatbarContext;
